module.exports = __webpack_public_path__ + "img/tianyi.0d9ecd8a.svg";